/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender user client side functions
-----------------------------------------------------------------------------*/

// The generic functions for Tender user side
var TECL_UserTenderGeneric = {

    // Reload the summary and change the sort order
    ChangeSummarySortOrder: function() {
        var tenderId = $("#TenderId").val();
        var sortTypeInt = $("#ddlTenderSummariesSortOrder").val();
        var showStatusControls = $("#tenderSupplierSummaryShowStatusControls").val();

        if (tenderId && sortTypeInt) {

            if (TECL_Master.AddLock("ChangeSummarySortOrder")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/ChangeTenderSummariesSortOrder",
                    type: "POST",
                    data: {
                        tenderId: tenderId,
                        sortTypeInt: sortTypeInt,
                        showStatusControls: showStatusControls
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ChangeSummarySortOrder");
                    },
                    success: function(viewHtml) {
                        TECL_Master.ClearLock("ChangeSummarySortOrder");
                        if (viewHtml) {
                            $("#tenderSummariesTable").html(viewHtml);
                        }
                    }
                });
            }
        }
    },

    // Display the file dowload dialog and show the case study file for the selected supplier
    DisplayCaseStudiesDownloadFiles: function(tenderSupplierId, supplierName) {
        if (tenderSupplierId && supplierName) {

            if (TECL_Master.AddLock("DisplayCaseStudiesDownloadFiles")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/GetCaseStudiesDownloadFileDatas",
                    type: "POST",
                    data: {
                        tenderSupplierId: tenderSupplierId,
                        supplierName: supplierName
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
                    },
                    success: function(viewHtml) {
                        TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
                        if (viewHtml) {
                            $("#DownloadFilesDialog").empty().html(viewHtml);
                            $("#tenderSupplierFileDownloadDialogData").modal("show");
                        }
                    }
                });
            }
        }
    },

    // Display the file dowload dialog and show the proposal file for the selected supplier
    DisplayProposalDownloadFilesDlg: function(tenderSupplierId, supplierName) {
        if (tenderSupplierId && supplierName) {

            if (TECL_Master.AddLock("DisplayProposalDownloadFilesDlg")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/GetProposalDownloadFileDatas",
                    type: "POST",
                    data: {
                        tenderSupplierId: tenderSupplierId,
                        supplierName: supplierName
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("DisplayProposalDownloadFilesDlg");
                    },
                    success: function(viewHtml) {
                        TECL_Master.ClearLock("DisplayProposalDownloadFilesDlg");
                        if (viewHtml) {
                            $("#DownloadFilesDialog").empty().html(viewHtml);
                            $("#tenderSupplierFileDownloadDialogData").modal("show");
                        }
                    }
                });
            }
        }
    },

    // Display the file dowload dialog and show the T&Cs file for the selected supplier
    DisplayTermsAndConditionsDownloadFilesDlg: function(tenderSupplierId, supplierName) {
        if (tenderSupplierId && supplierName) {

            if (TECL_Master.AddLock("DisplayCaseStudiesDownloadFiles")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/GetTermsAndConditionDownloadFileDatas",
                    type: "POST",
                    data: {
                        tenderSupplierId: tenderSupplierId,
                        supplierName: supplierName
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
                    },
                    success: function(viewHtml) {
                        TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
                        if (viewHtml) {
                            $("#DownloadFilesDialog").empty().html(viewHtml);
                            $("#tenderSupplierFileDownloadDialogData").modal("show");
                        }
                    }
                });
            }
        }
    },

    // Setup the new tender and call the page
    CreateNewTender: function() {
        if (TECL_Master.AddLock("CreateNewTender")) {
            $.ajax({
                url: baseSiteUrl + "TenderUserSurface/CreateNewTender",
                dataType: "json",
                type: "POST",
                data: {
                },
                error: function(exc) {
                    TECL_Master.ClearLock("CreateNewTender");
                },
                success: function(redirectUrl) {
                    TECL_Master.ClearLock("CreateNewTender");
                    if (redirectUrl) {
                        window.location = redirectUrl;
                    }
                }
            });
        }
    }

};

// The Tender submission edit functions
var TECL_UserTenderSubmissionEdit = {

    // Initialise the Tenders edit page
    Initialise: function() {

        // Hide the button columns
        $(".tenderSupplierSummaryButtonsCol").each(function() {
            $(this).addClass("hidden");
        });

        // Change the sorting type
        $("#ddlTenderSummariesSortOrder").change(function() {
            TECL_UserTenderGeneric.ChangeSummarySortOrder();
        });
    },

    // Submission continue button selected 
    ContinueSelected: function() {
        var tenderId = $("#TenderId").val();

        if (tenderId) {

            if (TECL_Master.AddLock("ContinueSelectedOnSubmission")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnSubmission",
                    dataType: "json",
                    type: "POST",
                    data: {
                        tenderId: tenderId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ContinueSelectedOnSubmission");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("ContinueSelectedOnSubmission");
                        if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                            window.location = saveData.NextStageUrl;
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to save stage change.");
                        }
                    }
                });
            }
        }
    }

};

// The Tender shortlisting edit functions
var TECL_UserTenderShortlistEdit = {

    // Initialise the Tenders edit page
    Initialise: function() {

        // Change the sorting type
        $("#ddlTenderSummariesSortOrder").change(function() {
            TECL_UserTenderGeneric.ChangeSummarySortOrder();
        });
    },

    // Shortlisting continue button selected 
    ContinueSelected: function() {
        var tenderId = $("#TenderId").val();

        if (tenderId) {

            if (TECL_Master.AddLock("ContinueSelectedOnShortlisting")) {

                if (TECL_UserTenderShortlistEdit.ValidatePage()) {
                    $.ajax({
                        url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnShortlisting",
                        dataType: "json",
                        type: "POST",
                        data: {
                            tenderId: tenderId
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("ContinueSelectedOnShortlisting");
                        },
                        success: function(saveData) {
                            TECL_Master.ClearLock("ContinueSelectedOnShortlisting");
                            if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog("Failed to save stage change.");
                            }
                        }
                    });
                } else {
                    $("#validationErrorDialog").modal("show");
                }
            }
        }
    },

    // Validate the current page
    ValidatePage: function() {
        var anySuppliersShortlistedStatus = false;
        var anySuppliersWithNonSelectStatus = false;

        $("#tenderSummariesTable").find("[name=supplierStatusButtons]").each(function() {
            if (!$(this).find("[name=RejectShortListingButtons]").hasClass("hidden")) {
                anySuppliersWithNonSelectStatus = true;
            } else if (!$(this).find("[name=UndoShortListingLink]").hasClass("hidden")) {
                anySuppliersShortlistedStatus = true;
            }
        });

        var isValid = anySuppliersShortlistedStatus && !anySuppliersWithNonSelectStatus;
        return isValid;
    },

    // Change the supplier status in the tender to the supplied value
    ChangeSupplierTenderStatus: function(supplierTenderId, rowId, newStatus) {

        if (supplierTenderId) {
            if (TECL_Master.AddLock("ChangeSupplierTenderStatus")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/ChangeTenderSupplierStatus",
                    dataType: "json",
                    type: "POST",
                    data: {
                        supplierTenderId: supplierTenderId,
                        newStatus: newStatus
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ChangeSupplierTenderStatus");
                    },
                    success: function(result) {
                        TECL_Master.ClearLock("ChangeSupplierTenderStatus");
                        if (result && result === true) {
                            if (newStatus === "reject") {
                                $("#" + rowId).find("[name=RejectShortListingButtons]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").removeClass("hidden");
                                $("#" + rowId).find("[name=UndoShortListingLink]").addClass("hidden");

                            } else if (newStatus === "shortlist") {
                                $("#" + rowId).find("[name=RejectShortListingButtons]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoShortListingLink]").removeClass("hidden");

                            } else if (newStatus === "undoreject" || newStatus === "undoshortlist") {
                                $("#" + rowId).find("[name=RejectShortListingButtons]").removeClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoShortListingLink]").addClass("hidden");
                            }
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to change supplier status.");
                        }
                    }
                });
            }
        }
    }

};

// The Tender presentation edit functions
var TECL_UserTenderPresentationEdit = {

    // Initialise the Tenders edit page
    Initialise: function() {
        TECL_DateTime.InitialiseDateTimePickers("#addContactRequestDialog");
    },

    // Presentation continue button selected 
    ContinueSelected: function() {
        var tenderId = $("#TenderId").val();

        if (tenderId) {

            if (TECL_Master.AddLock("ContinueSelectedOnPresentation")) {

                if (TECL_UserTenderPresentationEdit.ValidatePage()) {
                    $.ajax({
                        url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnPresentation",
                        dataType: "json",
                        type: "POST",
                        data: {
                            tenderId: tenderId
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("ContinueSelectedOnPresentation");
                        },
                        success: function(saveData) {
                            TECL_Master.ClearLock("ContinueSelectedOnPresentation");
                            if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog("Failed to save stage change.");
                            }
                        }
                    });
                } else {
                    $("#validationErrorDialog").modal("show");
                }
            }
        }
    },

    // Validate the current page
    ValidatePage: function() {
        var numberOfAwarded = 0;
        var anySuppliersWithNonSelectStatus = false;

        $("#tenderSummariesTable").find("[name=supplierStatusButtons]").each(function() {
            if (!$(this).find("[name=RejectAwardButtons]").hasClass("hidden")) {
                anySuppliersWithNonSelectStatus = true;
            } else if (!$(this).find("[name=UndoAwardLink]").hasClass("hidden")) {
                numberOfAwarded += 1;
            }
        });

        var isValid = numberOfAwarded === 1 && !anySuppliersWithNonSelectStatus;
        return isValid;
    },

    // Change the supplier status in the tender to the supplied value
    ChangeSupplierTenderStatus: function(supplierTenderId, rowId, newStatus) {

        if (supplierTenderId) {
            if (TECL_Master.AddLock("ChangeSupplierTenderStatus")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/ChangeTenderSupplierStatus",
                    dataType: "json",
                    type: "POST",
                    data: {
                        supplierTenderId: supplierTenderId,
                        newStatus: newStatus
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("ChangeSupplierTenderStatus");
                    },
                    success: function(result) {
                        TECL_Master.ClearLock("ChangeSupplierTenderStatus");
                        if (result && result === true) {
                            if (newStatus === "reject") {
                                $("#" + rowId).find("[name=RejectAwardButtons]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").removeClass("hidden");
                                $("#" + rowId).find("[name=UndoAwardLink]").addClass("hidden");

                            } else if (newStatus === "award") {
                                $("#" + rowId).find("[name=RejectAwardButtons]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoAwardLink]").removeClass("hidden");

                            } else if (newStatus === "undoreject" || newStatus === "undoaward") {
                                $("#" + rowId).find("[name=RejectAwardButtons]").removeClass("hidden");
                                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                                $("#" + rowId).find("[name=UndoAwardLink]").addClass("hidden");
                            }
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to change supplier status.");
                        }
                    }
                });
            }
        }
    },

    // Show the contact request dialog
    ShowContactRequestDialog: function(tenderSupplierId, supplierEmailAddress) {
        $("#addContactRequestDlgSupplierId").val(tenderSupplierId);
        $("#addContactRequestDlgSupplierEmailAddress").val(supplierEmailAddress);
        $("#addContactRequestDlgDate").val(null);
        $("#addContactRequestDlgTime").val(null);
        $("#addContactRequestDlgMessage").val("");
        $("#addContactRequestDialog").modal({
            backdrop: 'static',
            keyboard: false
        });
        $("#addContactRequestDialog").modal("show");
    },

    // Add a contact request
    AddContactRequest: function() {
        $("#supplierContactDateError").addClass("hidden");
        $("#supplierContactTimeError").addClass("hidden");

        var tenderId = $("#TenderId").val();
        var tenderSupplierId = $("#addContactRequestDlgSupplierId").val();
        var supplierEmailAddress = $("#addContactRequestDlgSupplierEmailAddress").val();
        var date = $("#addContactRequestDlgDate").val();
        var time = $("#addContactRequestDlgTime").val();
        var message = $("#addContactRequestDlgMessage").val();

        if (TECL_UserTenderPresentationEdit.ValidateContactRequest(tenderId, tenderSupplierId, date, time)) {

            if (TECL_Master.AddLock("AddContactRequest")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/AddContactRequest",
                    dataType: "json",
                    type: "POST",
                    data: {
                        tenderId: tenderId,
                        tenderSupplierId: tenderSupplierId,
                        date: date,
                        time: time,
                        message: message,
                        supplierEmailAddress: supplierEmailAddress
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("AddContactRequest");
                    },
                    success: function(result) {
                        $("#addContactRequestDialog").modal("hide");
                        TECL_Master.ClearLock("AddContactRequest");
                        if (result && result === true) {
                            TECL_TenderSupplierGeneral.DisplayNoticeDlg("Contact request sent to the supplier");
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to add contact request.");
                        }
                    }
                });
            }
        }
    },

    // Validate the contact request data
    ValidateContactRequest: function(tenderId, tenderSupplierId, date, time) {
        var valid = true;

        if (!tenderId || !tenderSupplierId) {
            valid = false;
        }

        if (!date) {
            $("#supplierContactDateError").removeClass("hidden");
            valid = false;
        }

        if (!time) {
            $("#supplierContactTimeError").removeClass("hidden");
            valid = false;
        }

        return valid;
    },

    // Open and close an answer
    OpenCloseSupplierNotes: function(supplierId) {
        var notesPanel = $("#supplierPrivateNotesPanel_" + supplierId).first();
        var openIcon = $("#notesOpenCloseIcon_" + supplierId).first();

        if (notesPanel && openIcon) {
            if ($(notesPanel).hasClass("hidden")) {
                $(notesPanel).removeClass("hidden");
                $(openIcon).removeClass("fa-plus");
                $(openIcon).addClass("fa-minus");
            } else {
                $(notesPanel).addClass("hidden");
                $(openIcon).removeClass("fa-minus");
                $(openIcon).addClass("fa-plus");
            }
        }
    },

    // Save the notes against a supplier
    SaveSupplierNotes: function(supplierTenderId, noteControlId) {
        var noteText = $("#" + noteControlId).val();

        if (supplierTenderId) {
            if (TECL_Master.AddLock("SaveSupplierNotes")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/SaveSupplierNotes",
                    dataType: "json",
                    type: "POST",
                    data: {
                        supplierTenderId: supplierTenderId,
                        noteText: noteText
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("SaveSupplierNotes");
                    },
                    success: function(result) {
                        TECL_Master.ClearLock("SaveSupplierNotes");

                        if (result && result === true) {
                            TECL_TenderSupplierGeneral.DisplayNoticeDlg("Supplier notes saved.");
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to save notes");
                        }
                    }
                });
            }
        }
    }

};

// The Tender award edit functions
var TECL_UserTenderAwardEdit = {

    // Initialise the Tenders edit page
    Initialise: function() {

    },

    // Award continue button selected 
    ContinueSelected: function() {

        var saveData = {
            TenderId: $("#TenderId").val(),
            FinalPrice: $("#tenderAwardFinalPriceValue").val(),
            MoneySaved: $("#tenderAwardPriceSavingValue").val(),
            StarRating: $("#tenderAwardStarRatingValue").val(),
            ImprovementText: $("#tenderAwardImprovementTextValue").val()
        }

        if (TECL_Master.AddLock("ContinueSelectedOnAward")) {
            $.ajax({
                url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnAward",
                dataType: "json",
                type: "POST",
                data: {
                    saveData: saveData
                },
                error: function(exc) {
                    TECL_Master.ClearLock("ContinueSelectedOnAward");
                },
                success: function(saveData) {
                    TECL_Master.ClearLock("ContinueSelectedOnAward");

                    if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                        window.location = saveData.NextStageUrl;
                    } else {
                        TECL_Master.ShowErrorDialog("Failed to save stage change.");
                    }
                }
            });
        }
    }

};

// The Tender supplier viewer functions
var TECL_TenderSupplierViewer = {

    // Save the Users question
    SaveUserQuestion: function() {
        var supplierTenderId = $("#TenderId").val();
        var parentTenderId = $("#ParentTenderId").val();

        $("#missingQuestionTextValidation").addClass("hidden");

        if (supplierTenderId && parentTenderId) {
            var questionText = $("#askQuestionText").val();

            if (questionText) {
                // Get the selected suppliers
                var supplierIds = [];
                supplierIds.push(supplierTenderId);
                $("#supplierAskQuestionDlg").find("[name=OtherSupplierInfos]").each(function() {
                    if ($(this).is(":checked")) {
                        supplierIds.push($(this).val());
                    }
                });

                if (TECL_Master.AddLock("SaveUserQuestion")) {
                    $.ajax({
                        url: baseSiteUrl + "TenderUserSurface/SaveUserQuestion",
                        type: "POST",
                        data: {
                            tenderId: parentTenderId,
                            questionText: questionText,
                            supplierIds: supplierIds
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("SaveUserQuestion");
                        },
                        success: function(questionHtml) {
                            TECL_Master.ClearLock("SaveUserQuestion");
                            $("#supplierAskQuestionDlg").modal("hide");

                            if (questionHtml) {
                                $("#tenderQuestionTitleRow").removeClass("hidden");
                                $("#supplierQuestionRows").after(questionHtml);
                                TECL_TenderSupplierGeneral.DisplayNoticeDlg("Question saved");
                            }
                        }
                    });
                }
            } else {
                $("#missingQuestionTextValidation").removeClass("hidden");
            }
        }
    },

    // Show the save question dialog
    ShowQuestionDialog: function() {
        // reset the dialog
        $("#askQuestionText").val("");

        $("#supplierAskQuestionDlg").find("[name=OtherSupplierInfos]").each(function() {
            $(this).prop('checked', false);
        });
        $("#missingQuestionTextValidation").addClass("hidden");

        // show the dialog
        $("#supplierAskQuestionDlg").modal({
            backdrop: 'static',
            keyboard: false
        });
        $("#supplierAskQuestionDlg").modal("show");
    },

    // Save the user answer
    SaveUserAnswer: function(questionId) {
        var tenderId = $("#TenderId").val();
        var answerText = $("#AnswerText_" + questionId).find("[name=answerText]").val();

        if (tenderId && questionId && answerText) {

            if (TECL_Master.AddLock("SaveUserAnswer")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/SaveUserAnswer",
                    type: "POST",
                    dataType: "json",
                    data: {
                        tenderId: tenderId,
                        answerText: answerText,
                        questionId: questionId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("SaveUserAnswer");
                    },
                    success: function(saved) {
                        TECL_Master.ClearLock("SaveUserAnswer");
                        if (saved && saved === true) {
                            TECL_TenderSupplierGeneral.DisplayNoticeDlg("Answer saved");
                        }
                    }
                });
            }
        }
    }

};
